module.exports = __webpack_public_path__ + "static/fancyTitleAlternativeBack-c0cfc769e096794ff6a09e9c456c5913.png";